import { render, staticRenderFns } from "./BookingProductCard.vue?vue&type=template&id=be5ba598&scoped=true&lang=pug&"
import script from "./BookingProductCard.vue?vue&type=script&lang=js&"
export * from "./BookingProductCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingProductCard.vue?vue&type=style&index=0&id=be5ba598&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5ba598",
  null
  
)

export default component.exports